/**
 * `<ObserverChip/>` — the top bar's read-only sign (#2060).
 *
 * Shown while an admin account has a team open that it is not a member
 * of: everything on screen is the team's lead view, and nothing on it
 * can be changed from this account. Honest signage, one line, no action.
 */
import { Eye } from "lucide-react";

import { cn } from "../../lib/cn";
import { OBSERVER_CHIP_LABEL } from "../../lib/teamAccess";

export function ObserverChip({ className }: { className?: string }) {
  return (
    <output
      className={cn(
        "inline-flex shrink-0 items-center gap-1.5 whitespace-nowrap rounded-full border border-warning/40 bg-warning-soft px-2.5 py-1 text-xs font-medium text-fg",
        className,
      )}
      data-testid="observer-chip"
      title="You are viewing this team from the Tarii admin account. Nothing here can be changed from this account."
    >
      <Eye className="h-3.5 w-3.5 text-fg-muted" aria-hidden="true" />
      {OBSERVER_CHIP_LABEL}
    </output>
  );
}
